var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 36H8.25C7.85254 35.9988 7.4717 35.8404 7.19065 35.5594C6.9096 35.2783 6.75119 34.8975 6.75 34.5V10.5C6.75119 10.1026 6.9096 9.72171 7.19065 9.44067C7.4717 9.15962 7.85254 9.0012 8.25 9.00002H36.75C37.1475 9.0012 37.5283 9.15962 37.8093 9.44067C38.0904 9.72171 38.2488 10.1026 38.25 10.5V13.5H12.75C12.3525 13.5012 11.9717 13.6596 11.6907 13.9407C11.4096 14.2217 11.2512 14.6026 11.25 15V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 36V37.5C11.2512 37.8975 11.4096 38.2783 11.6907 38.5594C11.9717 38.8404 12.3525 38.9988 12.75 39H39.75C40.1475 38.9988 40.5283 38.8404 40.8093 38.5594C41.0904 38.2783 41.2488 37.8975 41.25 37.5V15C41.2488 14.6026 41.0904 14.2217 40.8093 13.9407C40.5283 13.6596 40.1475 13.5012 39.75 13.5H12.75C12.3525 13.5012 11.9717 13.6596 11.6907 13.9407C11.4096 14.2217 11.2512 14.6026 11.25 15V36Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2.11765,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 32.25V37.5C41.2488 37.8975 41.0904 38.2783 40.8094 38.5594C40.5283 38.8404 40.1475 38.9988 39.75 39H37.5L34.5 36L27.75 29.25L29.25 27.75L33 24L41.25 32.25Z",
    fill: "#84CD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 39H12.75C12.3525 38.9988 11.9717 38.8404 11.6907 38.5594C11.4096 38.2783 11.2512 37.8975 11.25 37.5V35.25L22.5 24L27.75 29.25L34.5 36L37.5 39Z",
    fill: "#A5F368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 36H8.25C7.85254 35.9988 7.4717 35.8404 7.19065 35.5594C6.9096 35.2783 6.75119 34.8975 6.75 34.5V10.5C6.75119 10.1026 6.9096 9.72171 7.19065 9.44067C7.4717 9.15962 7.85254 9.0012 8.25 9.00002H36.75C37.1475 9.0012 37.5283 9.15962 37.8093 9.44067C38.0904 9.72171 38.2488 10.1026 38.25 10.5V11.25",
    stroke: "#4C5B66",
    strokeWidth: 2.11765,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 35.25L22.5 24L27.75 29.25L34.5 36",
    stroke: "#4C5B66",
    strokeWidth: 1.05882,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 32.25L32.75 24L29 27.75",
    fill: "#A5F368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 32.25L32.75 24L29 27.75",
    stroke: "#4C5B66",
    strokeWidth: 1.05882,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.086ee07b433385f515a5a52036a174b0.svg";
export { ForwardRef as ReactComponent };